'use client';

import config from '@packages/config';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { searchParamsToObject } from '@packages/shared/src/utils/searchParamsToObject/searchParamsToObject';
import { useSearchParams } from 'next/navigation';
import { useIntl } from 'react-intl';
import { useDynamicYieldTracking } from '../../../hooks/useDynamicYieldTracking';
import { rot47 } from '../../../utils/rot47';
import { SuccessPage } from '../SuccessPage.client';
import type { NewsletterSubscribePageProps } from '../types';
import IconNlSubscribe2Doi from './animated/IconNlSubscribe2Doi';
import { pagesMessages } from './helpers/messages';

export const Page2Doi = ({
  headline,
  text,
  buttonLabel,
  buttonLabelMobile,
}: NewsletterSubscribePageProps) => {
  const intl = useIntl();
  const { isMobile } = useDeviceType();

  const searchParams = useSearchParams();
  const query = searchParamsToObject(searchParams);
  const { token } = query;

  const customButtonLabel = isMobile ? buttonLabelMobile : buttonLabel;
  const finalButtonLabel = customButtonLabel ?? intl.formatMessage(pagesMessages.page2.subText);
  const email = token ? rot47(decodeURIComponent(token.toString())) : '';

  useDynamicYieldTracking(
    'newsletter-subscription-v1',
    email,
    config.forms.newsletterSettings.useDOI,
  );

  return (
    <SuccessPage
      icon={<IconNlSubscribe2Doi className="mx-auto my-0 mb-3 h-[8rem]" />}
      headline={headline ?? intl.formatMessage(pagesMessages.page2.headline)}
      description={text ?? intl.formatMessage(pagesMessages.page2.description)}
      button={{ text: intl.formatMessage(pagesMessages.page2.button) }}
      subtext={finalButtonLabel}
    />
  );
};
